<template>
  <div class="concept-audio-version">
    <p>
      <i class="fa-regular fa-headphones"></i>
      <strong>Audio Version</strong>
    </p>
    <audio
      controls
      ref="conceptAudioPlayer"
      @play="playStatus()"
      @pause="pauseStatus()"
      @ended="endedStatus()"
      @timeupdate="checkTime()"
      preload="auto"
    >
      <source :src="conceptAudioUrl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { showAudioPlayer, pauseAudioPlayer, endAudioPlayer, halfAudioPlayed, playAudioPlayer } from 'application/snowplow_player_events'

export default {
  props: {
    conceptId: {
      type: Number,
      required: true
    },
    conceptAudioUrl: {
      type: String,
      required: true
    },
    location: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      showPlaylist: false,
      currentTime: 0,
      listen50: true
    }
  },

  computed: {
    ...mapState([ 'current_time']),

    player() {
      return this.$refs.conceptAudioPlayer;
    }
  },

  mounted() {
    const savedTime = (this.$store.state.conceptTimes && this.$store.state.conceptTimes[this.conceptId]) || 0;

    if (savedTime > 0) {
      this.player.currentTime = savedTime;
    }

    showAudioPlayer(this.conceptId, this.location);
  },

  methods: {
    ...mapActions(['pushTrackTime']),

    pushTrackTimeData() {
      const trackData = { id: this.conceptId, time: this.currentTime };
      this.pushTrackTime(trackData);
    },

    pauseStatus() {
      pauseAudioPlayer(this.conceptId, this.location) // click on ‘pause’ event

      this.currentTime = this.player.currentTime
      this.pushTrackTimeData();
    },

    endedStatus() {
      endAudioPlayer(this.conceptId, this.location) // listened to 100% of the audio event

      this.currentTime = this.player.currentTime
      this.listen50 = true
      this.pushTrackTimeData();
    },

    checkTime() {
      const timePerc = this.player.currentTime*100/this.player.duration

      if (timePerc > 45 && timePerc < 55 && this.listen50) {
        this.listen50 = false

        halfAudioPlayed(this.conceptId, this.location) // listen to 50% of the audio event
      }
    },

    playStatus() {
      playAudioPlayer(this.conceptId, this.location) // click on ‘play’ event
    },
  }
}
</script>
